<template>
    <iv-modal
        :title="title"
        :width="width"
        :closable="false"
        v-model="sources.shown"
        @on-cancel="onCancel"
    >
    <iv-form
      :ref="FORM_NAME"
      :model="sources.formData"
      :label-width="100"
      label-position="left"
      :rules="options_validation.validation.formData">
      <iv-form-item label="项目年：" prop="year">
          <iv-select :disabled="type=='edit'" v-model="sources.formData.year">
              <iv-option v-for="item in options.year" :key="item.id" :value="item.id">
                  {{ item.name }}
              </iv-option>
          </iv-select>
      </iv-form-item>
      <iv-form-item label="公司：" prop="stockCode">
          <CompanySelect
            transfer
            filterable
            sourceType="carbonCompany"
            :disabled="type=='edit'"
            placeholder="请选择公司"
            :params="options.company.conditions"
            :value="options.company.value"
            @change="onCompanyChange"
            />
      </iv-form-item>
      <iv-form-item label="否决原因：" prop="yreasonear">
        <iv-input type="textarea" :rows="5" v-model="sources.formData.reason"></iv-input>
      </iv-form-item>
      <iv-form-item label="链接：" prop="link">
        <iv-input type="text" v-model="sources.formData.link"></iv-input>
      </iv-form-item>
    </iv-form>
    <iv-button type="text" size="large" slot="footer" @click="onCancel">取消</iv-button>
    <iv-button :loading="loader[COMPANY_VOTE]" type="primary" size="large" slot="footer" @click="onSuccess">保存</iv-button>
    </iv-modal>
</template>
<script>
import { BusinessError, RequestError, isNumber, getProductYear,carbon_years} from '@/utils/';
import ModelMixin from "@/mixins/Model.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";

import contact from "@/utils/contact";
import TargetModel from "@/models/TargetModel";
import CarbonIndustryModel from '@/models/CarbonIndustryModel'
import CarbonCompanyModel    from '@/models/CarbonCompanyModel'
import CarbonCompanyVoteModel    from '@/models/CarbonCompanyVoteModel'
import CompanySelect from "@/components/CompanySelect"

const TARGET = TargetModel.ModelName;
const INDUSTRY = CarbonIndustryModel.ModelName;
const COMPANY = CarbonCompanyModel.ModelName;
const COMPANY_VOTE = CarbonCompanyVoteModel.ModelName;

const FORM_NAME = `${COMPANY_VOTE}Form`;

export default {
    mixins: [
        LoaderMixin(
          TARGET,
          INDUSTRY,
          COMPANY
        ),
        ModelMixin({
            contact,
            models: [
              TargetModel,
              CarbonIndustryModel,
              CarbonCompanyModel,
              CarbonCompanyVoteModel,
            ],
        }),
    ],
    props: {
        width: {
            type: [String, Number],
            default: "500",
        },
        value: {
            type: Object,
            default: null,
        },
        title: String,
        type: {
            type: String,
            default:"create"
        },
        shown: Boolean,
    },
    watch: {
        shown(val) {
            this.sources.shown = val;
            if(!this.value){
              this.sources.formData = CarbonCompanyVoteModel.schema.default()
              this.options.company.conditions.abbreviation = ""
              this.options.company.value = []
            }else{
              this.sources.formData = { ...CarbonCompanyVoteModel.schema.default(), ...this.value }
              this.options.company.conditions.abbreviation = this.sources.formData.companyInfoCompanyName
              this.options.company.value = [this.sources.formData.stockCode]
              this.refreshCompanys({industryId: this.sources.formData.companyInfoIndustryId})
            }
        }
    },
    data() {
        return {
            FORM_NAME,
            TARGET,
            INDUSTRY,
            COMPANY,
            COMPANY_VOTE,
            options_validation: {
                validation: {
                    formData: CarbonCompanyVoteModel.validation()
                },
            },
            sources: {
                shown: false,
                formData: CarbonCompanyVoteModel.schema.default(),
            },
            secondTargetList:[],
            options:{
              year: carbon_years(),
              industry:[],
              company: {
                conditions: {
                  abbreviation: "",
                  industryId: "",
                  type: ""
                },
                list:[],
                value: [],
                pagination: {
                  page:1,
                  total:0,
                  limit:10,
                  offset:0
                }
              },
            }
        };
    },
    mounted(){
        this.refreshCompanys()
    },
    methods: {
        async refreshCompanys(opts){
            opts = {
              ...this.options.company.conditions,
              ...this.options.company.pagination,
              ...opts
            }
            const res = await this.$$fetch(COMPANY, opts)
            this.options.company.pagination.total = res.total.total
            return this.options.company.list = res.data.map(item=>({ id: item.stockCode, name: item.stockCode+' '+item.abbreviation }))
        },
        onCompanyChange(checkedList){
          const [value] = this.sources.formData.stockCode = checkedList
          this.sources.formData.stockCode = value
        },
        async onRemoteSearch(query){
          this.options.company.conditions.abbreviation = query
        },
        handleAdd(i) {
            this.sources.formData.sentimentList.push({ title: "", url:"", secondTargetNum:"", validation:false,  number: 1});
        },
        handleRemove(value){
            const { item,i } =value
            this.sources.formData.sentimentList.splice(i,1)
        },
        handleFormData(value){
            const { formData,i } = value
            this.sources.formData.sentimentList.splice(i,1,formData)
        },
        handleClose(event, name) {
            const index = this.tagsList.indexOf(name);
            this.tagsList.splice(index, 1);
        },
        onCancel() {
            this.hide();
        },
        async onSuccess(){
            const validate = await this.$refs[FORM_NAME].validate();
            if (!validate) {
                this.$$warning('表单验证不通过，请继续填写。');
                return Promise.reject(new Error('表单验证不通过，请继续填写。'));
            }
            const result_edit = await this.$$save(COMPANY_VOTE, { ...this.sources.formData })
            if ([BusinessError, RequestError, Error].indexOf(result_edit.constructor) == -1){
              this.hide()
              this.$$success(`${this.type=='edit'?'编辑':'新增'}成功！`)
              this.$emit('success')
            }
        },
        hide() {
            this.sources.shown = false;
            this.$refs[FORM_NAME].resetFields();
            this.$emit("shown-changed", this.sources.shown);
            this.sources.formData = CarbonCompanyVoteModel.schema.default()
            this.options.company.conditions.abbreviation = ""
            this.options.company.value = []
            // this.$emit("refresh");
        },
    },
    components:{
        CompanySelect
    }
};
</script>
<style scoped>
.ivu-tag {
    margin: 5px;
}
.panelList {
    list-style: none;
    padding: 18px 15px;
    font-size: 14px;
    line-height: 28px;
}
.radio-button {
    font-size: 15px;
    border-radius: 5px !important;
}
.addInput {
    margin: 5px;
    display: inline-block;
}

</style>
